import React from "react"
import { Link } from "gatsby"

// Antes usaba gatsby-plugin-transition-link (sin soporte para Gatsby 5). Ahora
// es un simple wrapper sobre el <Link> de Gatsby. Las props de transición
// (transitionName, exit, entry) se ignoran silenciosamente.
const CustomLink = React.forwardRef(({ to, title, children, className, style, onClick }, ref) => {
	return (
		<Link
			onClick={onClick}
			ref={ref}
			className={className}
			to={to}
			title={title}
			style={style}
		>
			{children}
		</Link>
	)
})
export default CustomLink;
